import React from 'react'

function Title() {
    return (
        <div className='name'>
           <h1><span>This ia a</span> React <span>Website</span></h1> 
           <p>Reference site about Lorem Ipsum, giving information on its origins, as well as a random Lipsum generator.</p>
           <div>
               <a href="#" className="cv-btn">Download</a>
           </div>
        </div>
    )
}

export default Title
